import { render, staticRenderFns } from "./coursePlayer.vue?vue&type=template&id=4bf066fd"
import script from "./coursePlayer.vue?vue&type=script&lang=js"
export * from "./coursePlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports